require('./DashboardModalTaskCollapsibleContent.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    {t} = require('services/i18nextWrapper'),
    uniqueId = require('lodash/uniqueId'),
    get = require('lodash/object').get,
    {cloneDeep} = require('lodash/lang'),
    {find, map, sortBy} = require('lodash/collection'),
    ContentUtils = require('utils/ContentUtils'),
    SessionStore = require('stores/SessionStore'),
    OrderUtils = require('utils/OrderUtils'),
    {FontIcon} = require('material-ui'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    DashboardModalTaskCollapsibleItem = require('./DashboardModalTaskCollapsibleItem'),
    DashboardModalTaskCollapsibleItemAmount = require('./DashboardModalTaskCollapsibleItemAmount');

const DashboardModalTaskCollapsibleContent = React.createClass({displayName: "DashboardModalTaskCollapsibleContent",

    propTypes: {
        order: PropTypes.object,
        orderProcess: PropTypes.array,
        existingProcess: PropTypes.object,
        existingTask: PropTypes.object,
        onBlurLabel: PropTypes.func,
        isCollapsed: PropTypes.bool,
        isEditMode: PropTypes.bool,
        onChangeProcess: PropTypes.func,
        onChangeProducts: PropTypes.func,
        onChangeAmountItem: PropTypes.func,
        onChangeAmountInLocation: PropTypes.func,
        onChangeVolumeItem: PropTypes.func,
        products: PropTypes.array,
        onConfirmProduct: PropTypes.func.isRequired
    },

    componentWillMount() {
        this.setState({
            keyAttrFirst: uniqueId('dmtcci_'),
            keyAttrSecond: uniqueId('dmtcc_')
        });
    },

    shouldComponentUpdate() {
        return this.isMounted();
    },

    componentDidMount() {
    },

    _getHydrateProcessWithOrderProcess() {
        const {existingTask, existingProcess} = this.props;
        let orderProcess;

        if (existingTask && existingTask.process && existingTask.process.length) {
            orderProcess = existingTask.process;
        } else {
            orderProcess = this.props.orderProcess;
        }
        const taskId = get(existingTask, 'taskId');

        if (!ContentUtils.isEmptyArray(orderProcess)) {
            // enter here means an existing order
            const hydratedProcess = map(existingProcess, existingProcessObj => {
                const existingProcessOrder = find(orderProcess,
                    orderProcessRow =>
                    +get(orderProcessRow, 'processId') === get(existingProcessObj, 'id') &&
                    get(orderProcessRow, 'taskId') === taskId
                );

                if (existingProcessOrder) {
                    existingProcessObj.fromDate = get(existingProcessOrder, 'fromDate', '');
                    existingProcessObj.toDate = get(existingProcessOrder, 'toDate', '');
                    existingProcessObj.fromHour = get(existingProcessOrder, 'fromHour', '');
                    existingProcessObj.toHour = get(existingProcessOrder, 'toHour', '');
                    existingProcessObj.note = get(existingProcessOrder, 'note', '');
                    existingProcessObj.taskId = get(existingProcessOrder, 'taskId', '');
                }

                return existingProcessObj;
            });

            return sortBy(hydratedProcess, 'sequenceOrder');

        } else {
            // enter here means is a new order, so nothing to hydrate
            return sortBy(existingProcess, 'sequenceOrder');
        }
    },

    _getProcessEl() {
        const orderProcessHydrated = this._getHydrateProcessWithOrderProcess();
        const {existingTask, onChangeProcess, order} = this.props;
        const keyAttrFirst = this.state.keyAttrFirst;
        const enableTasks = ContentUtils.filterEnable(orderProcessHydrated);

        if (ContentUtils.isEmptyArray(enableTasks)) {
            return (
                React.createElement("label", {style: {fontWeight: '200'}, className: "container text-center"}, 
                    React.createElement(FontIcon, {
                        style: {
                            top: '3px',
                            right: '4px',
                            fontSize: '18px',
                            color: '#fcca2e'
                        }, 
                        className: "material-icons"
                    }, "announcement"), ` ${t('dashboard_modal_task_qc_information')}`
                )
            );
        }

        return map(enableTasks, processAlreadyHydrated => {
            return (
                React.createElement(DashboardModalTaskCollapsibleItem, {
                    fromDate: get(processAlreadyHydrated, 'fromDate'), 
                    fromHour: get(processAlreadyHydrated, 'fromHour'), 
                    toDate: get(processAlreadyHydrated, 'toDate'), 
                    toHour: get(processAlreadyHydrated, 'toHour'), 
                    isSingle: get(order, 'isSingle'), 
                    uniqueId: keyAttrFirst, 
                    orderProcessHydrated: processAlreadyHydrated, 
                    existingTask: existingTask, 
                    onChangeProcess: onChangeProcess}
                )
            );
        });
    },

    _getProductsEl() {
        const {onChangeProducts, onChangeAmountItem, onChangeVolumeItem, existingTask, onChangeAmountInLocation, onConfirmProduct, order, shouldBeDisabled} = this.props;
        const products = get(existingTask, 'products');
        const isNewProduct = get(existingTask, 'isNewProduct');

        // only show product which may be disabled in case that those
        // already exist before ('isNewProduct') indicate that don't exist before.
        // means is a new assignment with no-product selected before.
        const enableProducts = isNewProduct ? ContentUtils.filterEnable(products) : products;
        const productsSorted = sortBy(enableProducts, 'name');
        const allowToConfirmProduct = OrderUtils.isAbleToConfirmSomeProduct(order, get(existingTask, 'date'));

        if (ContentUtils.isEmptyArray(productsSorted)) {
            return (
                React.createElement("label", {style: {fontWeight: '400'}, className: "container text-center"}, 
                    React.createElement(FontIcon, {
                        style: {
                            top: '3px',
                            right: '4px',
                            fontSize: '18px',
                            color: '#fcca2e'
                        }, 
                        className: "material-icons"
                    }, "announcement"), ` ${t('dashboard_modal_task_error_no_items_associated')}`
                )
            );
        }

        return map(productsSorted, (product, index) => {
            return (
                React.createElement(DashboardModalTaskCollapsibleItemAmount, {
                    shouldBeDisabled: shouldBeDisabled, 
                    onChangeProducts: onChangeProducts, 
                    onChangeAmountInLocation: onChangeAmountInLocation, 
                    onChangeAmountItem: onChangeAmountItem, 
                    onChangeVolumeItem: onChangeVolumeItem, 
                    onConfirmProduct: onConfirmProduct, 
                    uniqueId: `product-item-amount-${index}-${product.id}-${get(existingTask, 'taskId')}`, 
                    product: cloneDeep(product), 
                    allowToConfirmProduct: allowToConfirmProduct, 
                    task: existingTask, 
                    renderItemAgain: () => this.forceUpdate(), 
                    locations: DashboardServiceCache.getLocations()}
                )
            );
        });
    },

    _toggleVisibleStyle() {
        return this.props.isCollapsed ? {
                position: 'absolute',
                top: '2px',
                opacity: '0',
                height: '0',
                overflow: 'hidden'
            } : {
                position: 'relative',
                transition: 'opacity 1s ease-out',
                opacity: '1',
                height: 'auto',
                overflow: 'inherit',
                top: '2px'
            };
    },

    render() {
        const {keyAttrSecond} = this.state;

        // Process elements
        const orderProcessHydratedEl = this._getProcessEl();

        // Product elements
        const productsEl = this._getProductsEl();

        // turn to show/hide content list
        const listStyle = this._toggleVisibleStyle();

        return SessionStore.isFullPaidVersion() ? (
            React.createElement("ul", {key: keyAttrSecond, className: "dashboard-modal-task-collapsible-content__list", style: listStyle}, 
                React.createElement("h2", null, t('dashboard_modal_task_products_title')), 
                productsEl, 

                React.createElement("h2", null, t('dashboard_modal_task_qc_title')), 
                orderProcessHydratedEl
            )
        ) : (
            React.createElement("ul", {key: keyAttrSecond, className: "dashboard-modal-task-collapsible-content__list", style: listStyle}, 
                React.createElement("h2", null, t('dashboard_modal_task_qc_title')), 
                orderProcessHydratedEl
            )
        );
    }
});

module.exports = DashboardModalTaskCollapsibleContent;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsibleContent.jsx
 **/